import { useQuery } from "@redux-requests/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { types } from "../ducks";
import { getExhibitorProfiles } from "../ducks/actions";
import useUserMe from "./useUserMe";

const useExhibitorOwner = ({ exhibitorId }) => {
  const { user } = useUserMe();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getExhibitorProfiles({ exhibitorId }));
  }, [dispatch, exhibitorId]);

  const {
    data: { data: exhibitorProfiles },
    exhibitorProfilesLoading
  } = useQuery({ type: types.GET_EXHIBITOR_PROFILES, defaultData: { data: [] } });

  return (
    !exhibitorProfilesLoading && exhibitorProfiles.map(({ id }) => id).includes(user.profile.id)
  );
};

export default useExhibitorOwner;
